import { useState, useEffect } from "react";
import { Modal, Form, Input, Select, Button, Tabs, DatePicker, InputNumber, message, Row, Col, Space, } from "antd";
import { ArrowLeftOutlined, ArrowRightOutlined, SaveOutlined, CloseOutlined } from "@ant-design/icons";
import { createParticipante, updateParticipante, getCatalogosParticipante, } from "../../services/participant/participantesServices";
import dayjs from "dayjs";
const { Option } = Select;
const { TextArea } = Input;

const ParticipantForm = ({ isOpen, onClose, participant, onSuccess, mode }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [catalogos, setCatalogos] = useState({});
  const [activeTab, setActiveTab] = useState("personal");
  const [municipiosFiltrados, setMunicipiosFiltrados] = useState([]);
  const [departamento, setDepartamento] = useState(null);
  const [zonasFiltradas, setZonasFiltradas] = useState([]);
  const tabFieldsMap = {
    personal: ['nombre_participante', 'oid_tipo_identificacion', 'numero_identificacion', 'sexo', 'oid_proyecto', 'oid_implementador'],
    socioeconomico: ['ingresos_mensuales', 'oid_linea_economica', 'oid_nivel_escolaridad', 'cabeza_familia'],
    conyuge: ['nombre_conyuge', 'oid_tipo_identificacion_conyuge', 'identificacion_conyuge', 'numero_contacto_conyuge'],
    ubicacion: ['oid_departamento', 'oid_municipio', 'oid_zona_influencia', 'codigo_shape', 'nombre_predio'],
    productivo: ['num_hectarias_proyecto', 'oid_linea_productiva', 'oid_variedad_establecida'],
    contacto: ['numero_telefonico_1', 'correo_electronico', 'direccion_correspondencia', 'estado'],
  };

  useEffect(() => {
    if (isOpen) {
      loadCatalogos();
    }
  }, [isOpen]);

  useEffect(() => {
    if (isOpen && participant && (mode === "edit" || mode === "view") && catalogos.municipios) {
      const values = { ...participant };
      if (values.fecha_nacimiento) {
        values.fecha_nacimiento = dayjs(values.fecha_nacimiento);
      }
      const idFields = [
        'oid_tipo_identificacion',
        'oid_linea_economica',
        'oid_nivel_escolaridad',
        'oid_estado_civil',
        'oid_departamento',
        'oid_municipio',
        'oid_zona_influencia',
        'tenencia_predio',
        'oid_medio_transporte',
        'oid_linea_productiva',
        'oid_variedad_establecida',
        'oid_linea_productiva_segundaria',
        'oid_tipo_identificacion_conyuge',
        'oid_implementador',
        'oid_proyecto',
        'estado'
      ];
      idFields.forEach(field => {
        if (values[field] !== undefined && values[field] !== null) {
          values[field] = values[field].toString();
        }
      });
      if (values.oid_municipio) {
        const municipioSeleccionado = catalogos.municipios.find(
          m => m.oid.toString() === values.oid_municipio
        );
        if (municipioSeleccionado) {
          const deptoId = municipioSeleccionado.oid_depto?.toString();
          const municipiosDepto = catalogos.municipios?.filter(
            m => m.oid_depto?.toString() === deptoId
          ) || [];
          setMunicipiosFiltrados(municipiosDepto);
          const zonas = catalogos.zonas_influencia?.filter(
            z => z.id_municipio?.toString() === values.oid_municipio
          ) || [];
          setZonasFiltradas(zonas);
        }
      }
      setTimeout(() => {
        form.setFieldsValue(values);
      }, 0);
    } else if (isOpen && mode === "create") {
      form.resetFields();
      setActiveTab("personal");
    }
  }, [isOpen, participant, mode, catalogos]);

  const handleCancel = () => {
    if (form.isFieldsTouched()) {
      Modal.confirm({
        title: "Hay cambios sin guardar",
        content: "¿Seguro que quieres salir? Se perderán los cambios.",
        okText: "Sí, salir",
        cancelText: "No, volver",
        onOk: () => {
          form.resetFields();
          onClose();
        },
      });
    } else {
      onClose();
    }
  };

  const loadCatalogos = async () => {
    try {
      const { status, data } = await getCatalogosParticipante();
      if (status === 200) {
        setCatalogos(data);
        setMunicipiosFiltrados([]);
      }
    } catch (error) {
      console.error("Error loading catalogs:", error);
      message.error("Error al cargar los catálogos");
    }
  };

  const handleDepartamentoChange = (oidDepartamento) => {
    if (oidDepartamento) {

      const municipiosFiltrados = catalogos.municipios?.filter(
        municipio => municipio.oid_depto?.toString() === oidDepartamento
      ) || [];
      setDepartamento(oidDepartamento);
      setMunicipiosFiltrados(municipiosFiltrados);
      form.setFieldsValue({ oid_zona_influencia: undefined });
      form.setFieldsValue({ oid_municipio: undefined });
      setZonasFiltradas([]);
    } else {
      setDepartamento([]);
      setMunicipiosFiltrados([]);
      setZonasFiltradas([]);
      form.setFieldsValue({ oid_municipio: undefined });
      form.setFieldsValue({ oid_zona_influencia: undefined });
    }
  };

  const handleMunicipioChange = (oidMunicipio) => {
    if (oidMunicipio) {
      const zonas = catalogos.zonas_influencia?.filter(
        z => z.id_municipio?.toString() === oidMunicipio
      ) || [];
      setZonasFiltradas(zonas);
      form.setFieldsValue({ oid_zona_influencia: undefined });
    } else {
      setZonasFiltradas([]);
      form.setFieldsValue({ oid_zona_influencia: undefined });
    }
  };

  const handleSubmit = async () => {
    if (mode === "view") return;
    try {
      setLoading(true);
      let values;
      try {
        const allFields = form.getFieldsValue(true);
        values = await form.validateFields();
        values = { ...allFields, ...values };
      } catch (error) {
        if (error.errorFields && error.errorFields.length > 0) {
          message.error(`Debes completar los campos obligatorios`);
          const firstErrorField = error.errorFields[0].name[0];
          const targetTab = Object.keys(tabFieldsMap).find((tab) =>
            tabFieldsMap[tab].includes(firstErrorField)
          );
          if (targetTab) {
            setActiveTab(targetTab);
            setTimeout(() => {
              form.scrollToField(error.errorFields[0].name);
            }, 100);
          }
          return;
        }
        throw error;
      }
      const transformedValues = transformParticipanteData(values, mode);
      let response;
      if (mode === "create") {
        if (!transformedValues.nombre_participante || !transformedValues.numero_identificacion) {
          message.error("Los campos Nombre del Participante y Número de Identificación son obligatorios.");
          setActiveTab("personal");
        } else
          if (!transformedValues.oid_municipio || !transformedValues.oid_zona_influencia) {
            message.error("Los campos Municipio y Zona de Influencia son obligatorios.");
            setActiveTab("ubicacion");
          } else {
            response = await createParticipante(transformedValues);
          }
      } else {
        response = await updateParticipante(
          participant.oid,
          transformedValues,
          participant.oid_participante_proyecto
        );
      }

      if (response && (response.status === 200 || response.status === 201)) {
        const participanteFinal = {
          ...participant,
          ...transformedValues,
          oid: participant?.oid || response.data.oid_participante,
          oid_departamento: departamento
        };
        message.success(
          mode === "create"
            ? "Participante creado correctamente"
            : "Participante actualizado correctamente"
        );
        onClose();
        onSuccess && onSuccess(participanteFinal);
      } else if (response) {
        throw new Error(response.message || "Error en la operación");
      }

    } catch (error) {
      console.error("Error:", error);
      if (!error.errorFields) {
        message.error(error.message || "Error al procesar la solicitud");
      }
    } finally {
      setLoading(false);
    }
  };

  const transformParticipanteData = (data, mode) => {

    const allowedFields = [
      'oid', 'nombre_participante', 'oid_tipo_identificacion', 'numero_identificacion',
      'sexo', 'fecha_nacimiento', 'sabe_leer_escribir', 'ingresos_mensuales',
      'oid_linea_economica', 'oid_nivel_escolaridad', 'cabeza_familia', 'num_personas_cargo',
      'total_nucleo_familiar', 'oid_estado_civil', 'vinculado_alguna_organizacion',
      'nombre_conyuge', 'oid_tipo_identificacion_conyuge', 'identificacion_conyuge',
      'numero_contacto_conyuge', 'oid_municipio', 'oid_zona_influencia', 'codigo_shape',
      'nombre_predio', 'tenencia_predio', 'latitud', 'longitud', 'num_hectarias_proyecto',
      'oid_linea_productiva', 'oid_variedad_establecida', 'oid_linea_productiva_segundaria',
      'num_hectareas', 'produccion_anual', 'distancia_cabecera_municipal',
      'tiempo_cabecera_municipal', 'oid_medio_transporte', 'vive_mismo_lugar',
      'lugar_vivienda', 'direccion_correspondencia', 'numero_telefonico_1',
      'numero_telefonico_2', 'correo_electronico', 'telefonica', 'internet', 'estado',
      'oid_proyecto', 'oid_implementador'
    ];

    const filteredData = {};
    allowedFields.forEach(field => {
      if (data[field] !== undefined) {
        filteredData[field] = data[field];
      }
    });

    if (filteredData.fecha_nacimiento && dayjs.isDayjs(filteredData.fecha_nacimiento)) {
      filteredData.fecha_nacimiento = filteredData.fecha_nacimiento.format('YYYY-MM-DD');
    }

    const numericFields = [
      'ingresos_mensuales', 'num_personas_cargo', 'total_nucleo_familiar',
      'distancia_cabecera_municipal', 'tiempo_cabecera_municipal',
      'num_hectarias_proyecto', 'num_hectareas'
    ];

    numericFields.forEach(field => {
      if (filteredData[field] !== undefined && filteredData[field] !== null) {
        filteredData[field] = Number(filteredData[field]);
      }
    });

    Object.keys(filteredData).forEach(key => {
      if (filteredData[key] === undefined) {
        filteredData[key] = null;
      }
    });

    return filteredData;
  };

  const getModalTitle = () => {
    switch (mode) {
      case "create":
        return "Crear Participante";
      case "edit":
        return "Editar Participante";
      case "view":
        return "Ver Participante";
      default:
        return "Participante";
    }
  };

  const isReadOnly = mode === "view";

  const renderPersonalInfo = () => (
    <Row gutter={[16, 16]}>
      <Col xs={24} sm={12} lg={8}>
        <Form.Item
          name="nombre_participante"
          label="Nombre Completo"
          rules={[{ required: true, message: "Este campo es obligatorio" }]}
        >
          <Input disabled={isReadOnly} placeholder="Ingrese nombre completo" />
        </Form.Item>
      </Col>

      <Col xs={24} sm={12} lg={8}>
        <Form.Item
          name="oid_tipo_identificacion"
          label="Tipo de Identificación"
          rules={[{ required: true, message: "Este campo es obligatorio" }]}
        >
          <Select disabled={isReadOnly} placeholder="Seleccionar tipo">
            {catalogos.tipos_identificacion?.map((tipo) => (
              <Option key={tipo.oid} value={tipo.oid.toString()}>
                {tipo.tipo_identificacion}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>

      <Col xs={24} sm={12} lg={8}>
        <Form.Item
          name="numero_identificacion"
          label="Número de Identificación"
          rules={[{ required: true, message: "Este campo es obligatorio" }]}
        >
          <Input disabled={isReadOnly} placeholder="Ingrese número de identificación" />
        </Form.Item>
      </Col>

      <Col xs={24} sm={12} lg={8}>
        <Form.Item
          name="sexo"
          label="Sexo"
          rules={[{ required: true, message: "Este campo es obligatorio" }]}
        >
          <Select disabled={isReadOnly} placeholder="Seleccionar sexo">
            <Option value="Hombre">Hombre</Option>
            <Option value="Mujer">Mujer</Option>
          </Select>
        </Form.Item>
      </Col>

      <Col xs={24} sm={12} lg={8}>
        <Form.Item name="fecha_nacimiento" label="Fecha de Nacimiento">
          <DatePicker
            disabled={isReadOnly}
            placeholder="Seleccionar fecha"
            style={{ width: "100%" }}
            format="DD/MM/YYYY"
          />
        </Form.Item>
      </Col>

      <Col xs={24} sm={12} lg={8}>
        <Form.Item name="sabe_leer_escribir" label="¿Sabe Leer y Escribir?">
          <Select disabled={isReadOnly} placeholder="Seleccionar">
            <Option value="SI">Sí</Option>
            <Option value="NO">No</Option>
          </Select>
        </Form.Item>
      </Col>
      <Col xs={24} sm={12} lg={8}>
        <Form.Item
          name="oid_proyecto"
          label="Proyectos"
          rules={[{ required: true, message: "Este campo es obligatorio" }]}
        >
          <Select
            showSearch
            allowClear
            disabled={isReadOnly}
            placeholder="Seleccionar proyecto"
            optionFilterProp="children" // filtra por el texto de la opción
            filterOption={(input, option) =>
              option?.children
                ?.toString()
                .toLowerCase()
                .includes(input.toLowerCase())
            }
          >
            {catalogos.proyectos?.map((tipo) => (
              <Option key={tipo.oid} value={tipo.oid.toString()}>
                {tipo.codigo} - {tipo.proyecto}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>

      <Col xs={24} sm={12} lg={8}>
        <Form.Item
          name="oid_implementador"
          label="Implementador"
          rules={[{ required: true, message: "Este campo es obligatorio" }]}
        >
          <Select disabled={isReadOnly} placeholder="Seleccionar tipo">
            {catalogos.implementadores?.map((tipo) => (
              <Option key={tipo.oid} value={tipo.oid.toString()}>
                {tipo.Implemetador}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
    </Row>
  );

  const renderSocioeconomicInfo = () => (
    <Row gutter={[16, 16]}>
      <Col xs={24} sm={12} lg={8}>
        <Form.Item name="ingresos_mensuales" label="Ingresos Mensuales">
          <InputNumber
            disabled={isReadOnly}
            style={{ width: "100%" }}
            min={0}
            formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
            parser={value => value.replace(/\$\s?|(,*)/g, '')}
          />
        </Form.Item>
      </Col>

      <Col xs={24} sm={12} lg={8}>
        <Form.Item
          name="oid_linea_economica"
          label="Línea Económica"
        >
          <Select
            showSearch
            allowClear
            disabled={isReadOnly}
            placeholder="Seleccionar línea económica"
            optionFilterProp="children"
            filterOption={(input, option) =>
              option?.children
                ?.toString()
                .toLowerCase()
                .includes(input.toLowerCase())
            }
          >
            {catalogos.lineas_economicas?.map((linea) => (
              <Option key={linea.oid} value={linea.oid.toString()}>
                {linea.linea_economica_principal}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>


      <Col xs={24} sm={12} lg={8}>
        <Form.Item name="oid_nivel_escolaridad" label="Nivel de Escolaridad">
          <Select disabled={isReadOnly} placeholder="Seleccionar nivel">
            {catalogos.niveles_escolaridad?.map((nivel) => (
              <Option key={nivel.oid} value={nivel.oid.toString()}>
                {nivel.nivel_escolaridad}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>

      <Col xs={24} sm={12} lg={8}>
        <Form.Item name="cabeza_familia" label="¿Es Cabeza de Familia?">
          <Select disabled={isReadOnly} placeholder="Seleccionar">
            <Option value="SI">Sí</Option>
            <Option value="NO">No</Option>
          </Select>
        </Form.Item>
      </Col>

      <Col xs={24} sm={12} lg={8}>
        <Form.Item name="num_personas_cargo" label="Número de Personas a Cargo">
          <InputNumber disabled={isReadOnly} min={0} style={{ width: "100%" }} />
        </Form.Item>
      </Col>

      <Col xs={24} sm={12} lg={8}>
        <Form.Item name="total_nucleo_familiar" label="Total Núcleo Familiar">
          <InputNumber disabled={isReadOnly} min={0} style={{ width: "100%" }} />
        </Form.Item>
      </Col>

      <Col xs={24} sm={12} lg={8}>
        <Form.Item name="oid_estado_civil" label="Estado Civil">
          <Select disabled={isReadOnly} placeholder="Seleccionar estado civil">
            {catalogos.estados_civiles?.map((estado) => (
              <Option key={estado.oid} value={estado.oid.toString()}>
                {estado.estado_civil}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>

      <Col xs={24} sm={12} lg={8}>
        <Form.Item name="vinculado_alguna_organizacion" label="¿Vinculado a Alguna Organización?">
          <Select disabled={isReadOnly} placeholder="Seleccionar">
            <Option value="SI">Sí</Option>
            <Option value="NO">No</Option>
          </Select>
        </Form.Item>
      </Col>
    </Row>
  );

  const renderSpouseInfo = () => (
    <Row gutter={[16, 16]}>
      <Col xs={24} sm={12}>
        <Form.Item name="nombre_conyuge" label="Nombre del Cónyuge">
          <Input disabled={isReadOnly} placeholder="Ingrese nombre del cónyuge" />
        </Form.Item>
      </Col>

      <Col xs={24} sm={12}>
        <Form.Item name="oid_tipo_identificacion_conyuge" label="Tipo de Identificación del Cónyuge">
          <Select disabled={isReadOnly} placeholder="Seleccionar tipo">
            {catalogos.tipos_identificacion?.map((tipo) => (
              <Option key={tipo.oid} value={tipo.oid.toString()}>
                {tipo.tipo_identificacion}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>

      <Col xs={24} sm={12}>
        <Form.Item name="identificacion_conyuge" label="Identificación del Cónyuge">
          <Input disabled={isReadOnly} placeholder="Ingrese identificación" />
        </Form.Item>
      </Col>

      <Col xs={24} sm={12}>
        <Form.Item name="numero_contacto_conyuge" label="Número de Contacto del Cónyuge">
          <Input disabled={isReadOnly} placeholder="Ingrese número de contacto" />
        </Form.Item>
      </Col>
    </Row>
  );

  const renderLocationInfo = () => (
    <Row gutter={[16, 16]}>
      <Col xs={24} sm={12} lg={8}>
        <Form.Item
          name="oid_departamento"
          label="Departamento"
        >
          <Select
            showSearch
            disabled={isReadOnly}
            placeholder="Seleccionar departamento"
            onChange={handleDepartamentoChange}

            optionFilterProp="children"
            filterOption={(input, option) =>
              option?.children
                ?.toString()
                .toLowerCase()
                .includes(input.toLowerCase())
            }
            allowClear
          >
            {catalogos.departamentos?.map((departamento) => (
              <Option key={departamento.oid} value={departamento.oid.toString()}>
                {departamento.departamento}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
      <Col xs={24} sm={12} lg={8}>
        <Form.Item
          name="oid_municipio"
          label="Municipio"
          rules={[{ required: true, message: "Este campo es obligatorio" }]}
        >
          <Select
            showSearch
            allowClear
            disabled={isReadOnly}
            placeholder="Seleccionar municipio"
            onChange={handleMunicipioChange}
            optionFilterProp="children"
            filterOption={(input, option) =>
              option?.children?.toString().toLowerCase().includes(input.toLowerCase())
            }
          >
            {municipiosFiltrados.map((municipio) => (
              <Option key={municipio.oid} value={municipio.oid.toString()}>
                {municipio.municipio}
              </Option>
            ))}
          </Select>
        </Form.Item>

      </Col>

      <Col xs={24} sm={12} lg={8}>
        <Form.Item name="oid_zona_influencia" label="Zona de Influencia" rules={[{ required: true, message: "Este campo es obligatorio" }]}>
          <Select
            showSearch
            allowClear
            disabled={isReadOnly}
            placeholder="Seleccionar zona"
            optionFilterProp="children"
            filterOption={(input, option) =>
              option?.children?.toString().toLowerCase().includes(input.toLowerCase())
            }>
            {zonasFiltradas.map((zona) => (
              <Option key={zona.oid} value={zona.oid.toString()}>
                {zona.zona_influencia}
              </Option>
            ))}
          </Select>
        </Form.Item>

      </Col>

      <Col xs={24} sm={12} lg={8}>
        <Form.Item name="codigo_shape" label="Código Shape">
          <Input disabled={isReadOnly} placeholder="Ingrese código shape" />
        </Form.Item>
      </Col>

      <Col xs={24} sm={12} lg={8}>
        <Form.Item name="nombre_predio" label="Nombre del Predio">
          <Input disabled={isReadOnly} placeholder="Ingrese nombre del predio" />
        </Form.Item>
      </Col>

      <Col xs={24} sm={12} lg={8}>
        <Form.Item name="tenencia_predio" label="Tenencia del Predio">
          <Select disabled={isReadOnly} placeholder="Seleccionar tenencia">
            {catalogos.tenencia_predios?.map((tenencia) => (
              <Option key={tenencia.oid} value={tenencia.oid.toString()}>
                {tenencia.relacion_tenencia_predio}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>

      <Col xs={24} sm={12} lg={8}>
        <Form.Item name="latitud" label="Latitud">
          <Input disabled={isReadOnly} placeholder="Ingrese latitud" />
        </Form.Item>
      </Col>

      <Col xs={24} sm={12} lg={8}>
        <Form.Item name="longitud" label="Longitud">
          <Input disabled={isReadOnly} placeholder="Ingrese longitud" />
        </Form.Item>
      </Col>

      <Col xs={24} sm={12} lg={8}>
        <Form.Item
          name="distancia_cabecera_municipal"
          label="Distancia a Cabecera Municipal (Km)"
        >
          <InputNumber
            disabled={isReadOnly}
            min={0}               // no permite negativos
            step={0.1}            // puedes definir el salto (ej: 0.1 = decimales)
            style={{ width: "100%" }}
            placeholder="Ingrese distancia"
          />
        </Form.Item>
      </Col>


      <Col xs={24} sm={12} lg={8}>
        <Form.Item name="tiempo_cabecera_municipal" label="Tiempo a Cabecera Municipal (Min)">
          <InputNumber disabled={isReadOnly} min={0} style={{ width: "100%" }} />
        </Form.Item>
      </Col>

      <Col xs={24} sm={12} lg={8}>
        <Form.Item name="oid_medio_transporte" label="Medio de Transporte">
          <Select disabled={isReadOnly} placeholder="Seleccionar medio">
            {catalogos.medios_transporte?.map((medio) => (
              <Option key={medio.oid} value={medio.oid.toString()}>
                {medio.medio_trasporte}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>

      <Col xs={24} sm={12} lg={8}>
        <Form.Item name="vive_mismo_lugar" label="¿Vive en el Mismo Lugar del Proyecto?">
          <Select disabled={isReadOnly} placeholder="Seleccionar">
            <Option value="SI">Sí</Option>
            <Option value="NO">No</Option>
          </Select>
        </Form.Item>
      </Col>

      <Col xs={24}>
        <Form.Item name="lugar_vivienda" label="Lugar de Vivienda">
          <Input disabled={isReadOnly} placeholder="Ingrese lugar de vivienda" />
        </Form.Item>
      </Col>
    </Row>
  );

  const renderProductiveInfo = () => (
    <Row gutter={[16, 16]}>
      <Col xs={24} sm={12} lg={8}>
        <Form.Item name="num_hectarias_proyecto" label="Número de Hectáreas del Proyecto">
          <InputNumber
            disabled={isReadOnly}
            min={0}
            step={0.01}
            style={{ width: "100%" }}
          />
        </Form.Item>
      </Col>

      <Col xs={24} sm={12} lg={8}>
        <Form.Item name="oid_linea_productiva" label="Línea Productiva">
          <Select disabled={isReadOnly} placeholder="Seleccionar línea productiva"
            showSearch optionFilterProp="children"
            filterOption={(input, option) =>
              option?.children?.toString().toLowerCase().includes(input.toLowerCase())
            } >
            {catalogos.lineas_productivas?.map((linea) => (
              <Option key={linea.oid} value={linea.oid.toString()}>
                {linea.linea_productiva}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>

      <Col xs={24} sm={12} lg={8}>
        <Form.Item name="oid_variedad_establecida" label="Variedad Establecida">
          <Select disabled={isReadOnly} placeholder="Seleccionar variedad"
            showSearch optionFilterProp="children"
            filterOption={(input, option) =>
              option?.children?.toString().toLowerCase().includes(input.toLowerCase())
            }
          >
            {catalogos.variedades_establecidas?.map((variedad) => (
              <Option key={variedad.oid} value={variedad.oid.toString()}>
                {variedad.variedad_establecida}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>

      <Col xs={24} sm={12} lg={8}>
        <Form.Item name="oid_linea_productiva_segundaria" label="Línea Productiva Secundaria">
          <Select disabled={isReadOnly} placeholder="Seleccionar línea secundaria" showSearch optionFilterProp="children"
            filterOption={(input, option) =>
              option?.children?.toString().toLowerCase().includes(input.toLowerCase())
            }>
            {catalogos.lineas_productivas?.map((linea) => (
              <Option key={linea.oid} value={linea.oid.toString()}>
                {linea.linea_productiva}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>

      <Col xs={24} sm={12} lg={8}>
        <Form.Item name="num_hectareas" label="Número de Hectáreas">
          <InputNumber
            disabled={isReadOnly}
            min={0}
            step={0.01}
            style={{ width: "100%" }}
          />
        </Form.Item>
      </Col>

      <Col xs={24}>
        <Form.Item name="produccion_anual" label="Producción Anual">
          <TextArea
            disabled={isReadOnly}
            rows={3}
            placeholder="Describa la producción anual"
          />
        </Form.Item>
      </Col>
    </Row>
  );

  const renderContactInfo = () => (
    <Row gutter={[16, 16]}>
      <Col xs={24} sm={12}>
        <Form.Item name="numero_telefonico_1" label="Teléfono Principal">
          <Input disabled={isReadOnly} placeholder="Ingrese teléfono principal" />
        </Form.Item>
      </Col>

      <Col xs={24} sm={12}>
        <Form.Item name="numero_telefonico_2" label="Teléfono Secundario">
          <Input disabled={isReadOnly} placeholder="Ingrese teléfono secundario" />
        </Form.Item>
      </Col>

      <Col xs={24} sm={12}>
        <Form.Item name="correo_electronico" label="Correo Electrónico">
          <Input
            disabled={isReadOnly}
            type="email"
            placeholder="Ingrese correo electrónico"
          />
        </Form.Item>
      </Col>

      <Col xs={24} sm={12}>
        <Form.Item
          name="telefonica"
          label="¿Cuenta con servicio telefónico?"

        >
          <Select disabled={isReadOnly} placeholder="Seleccione una opción">
            <Option value="si">Sí</Option>
            <Option value="no">No</Option>
          </Select>
        </Form.Item>
      </Col>

      <Col xs={24} sm={12}>
        <Form.Item
          name="internet"
          label="¿Cuenta con acceso a Internet?"

        >
          <Select disabled={isReadOnly} placeholder="Seleccione una opción">
            <Option value="si">Sí</Option>
            <Option value="no">No</Option>
          </Select>
        </Form.Item>
      </Col>
      <Col xs={24} sm={12}>
        <Form.Item
          name="estado"
          label="Estado"
          initialValue="1" // 👈 Activo por defecto
          rules={[{ required: true, message: "Este campo es obligatorio" }]}
        >
          <Select disabled={isReadOnly} placeholder="Seleccione estado">
            <Option value="1">Activo</Option>
            <Option value="2">Inactivo</Option>
          </Select>
        </Form.Item>

      </Col>


      <Col xs={24}>
        <Form.Item name="direccion_correspondencia" label="Dirección de Correspondencia">
          <TextArea
            disabled={isReadOnly}
            rows={3}
            placeholder="Ingrese dirección de correspondencia"
          />
        </Form.Item>
      </Col>
    </Row>
  );

  const tabItems = [
    {
      key: "personal",
      label: "Personal",
      children: renderPersonalInfo(),
    },
    {
      key: "socioeconomico",
      label: "Socioeconómico",
      children: renderSocioeconomicInfo(),
    },
    {
      key: "conyuge",
      label: "Cónyuge",
      children: renderSpouseInfo(),
    },
    {
      key: "ubicacion",
      label: "Ubicación",
      children: renderLocationInfo(),
    },
    {
      key: "productivo",
      label: "Productivo",
      children: renderProductiveInfo(),
    },
    {
      key: "contacto",
      label: "Otros datos",
      children: renderContactInfo(),
    },
  ];

  const handleTabChange = async (key) => {
    setActiveTab(key);
  };

  const navigateTabs = async (direction) => {
    const isValid = await validateCurrentTab();
    if (!isValid) return; // Si hay error, no cambia de pestaña
    const tabs = ["personal", "socioeconomico", "conyuge", "ubicacion", "productivo", "contacto"];
    const currentIndex = tabs.indexOf(activeTab);
    if (direction === "prev" && currentIndex > 0) {
      setActiveTab(tabs[currentIndex - 1]);
    } else if (direction === "next" && currentIndex < tabs.length - 1) {
      setActiveTab(tabs[currentIndex + 1]);
    }
  };

  const footerContent = (
    <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: "8px" }}>
      <Space>
        {activeTab !== "personal" && (
          <Button
            icon={<ArrowLeftOutlined />}
            onClick={() => navigateTabs("prev")}
            size="middle"
          >
            Anterior
          </Button>
        )}
        {activeTab !== "contacto" && (
          <Button
            type="primary"
            icon={<ArrowRightOutlined />}
            onClick={() => navigateTabs("next")}
            size="middle"
          >
            Siguiente
          </Button>
        )}
      </Space>

      <Space>
        <Button onClick={onClose} icon={<CloseOutlined />}>
          {mode === "view" ? "Cerrar" : "Cancelar"}
        </Button>
        {mode !== "view" && (
          <Button
            type="primary"
            loading={loading}
            onClick={handleSubmit}
            icon={<SaveOutlined />}
          >
            {mode === "create" ? "Crear" : "Actualizar"}
          </Button>
        )}
      </Space>
    </div>
  );

  const validateCurrentTab = async () => {
    try {
      await form.validateFields(tabFieldsMap[activeTab]);
      return true;
    } catch (error) {
      if (error.errorFields && error.errorFields.length > 0) {
        message.error(error.errorFields[0].errors[0]);
        form.scrollToField(error.errorFields[0].name);
      }
      return false;
    }
  };

  return (
    <Modal
      title={getModalTitle()}
      open={isOpen}
      onCancel={handleCancel}
      footer={footerContent}
      width="95%"
      style={{ maxWidth: 1200 }}
      styles={{ body: { padding: "16px", maxHeight: "70vh", overflowY: "auto" } }}
      destroyOnHidden
    >
      <Form
        form={form}
        layout="vertical"
        disabled={isReadOnly}
        initialValues={{ estado: "1" }}
      >
        <Tabs
          activeKey={activeTab}
          onChange={handleTabChange}
          type="card"
          items={tabItems}
        />
      </Form>
    </Modal>
  );
};

export default ParticipantForm;